if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      onSlideChanged(event) {
        const gallery = this.openedBy?.closest('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

        const mediaId = event.detail.currentElement.dataset.mediaId;
        const gallerySlide = gallery.querySelector(`[data-media-id$="${mediaId}"]`);
        if (gallerySlide) {
          gallery.setActiveMedia(gallerySlide.dataset.mediaId, false);
          const newOpener = gallerySlide.querySelector('button');
          if (newOpener) this.openedBy = newOpener;
        }
      }

      sync(mediaId) {
        this.dataset.pendingMediaId = mediaId;
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const slider = this.querySelector('[id^="Slider-"]');
        if (slider && slider.offsetWidth > 0) {
          slider.scrollTo({ left: activeMedia.offsetLeft });
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        const slider = this.querySelector('[id^="Slider-"]');
        const sliderComponent = slider?.closest('slider-component');
        if (sliderComponent && !sliderComponent.dataset.syncBound) {
          sliderComponent.addEventListener('slideChanged', (event) => {
            this.onSlideChanged(event);
          });
          sliderComponent.dataset.syncBound = 'true';
        }
        try { window.bfTheme?.recalculateAllPrices?.(); } catch (e) {}
      }

      showActiveMedia() {
        const mediaId = this.dataset.pendingMediaId || this.openedBy.getAttribute('data-media-id');
        delete this.dataset.pendingMediaId;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const slider = this.querySelector('[id^="Slider-"]');
        if (slider) {
          const performScroll = () => {
            slider.style.scrollBehavior = 'auto';
            slider.scrollTo({ left: activeMedia.offsetLeft });
            slider.style.scrollBehavior = '';
          };

          if (activeMedia.offsetLeft === 0 && activeMedia !== slider.firstElementChild) {
            requestAnimationFrame(performScroll);
          } else {
            performScroll();
          }

          const sliderComponent = slider.closest('slider-component');
          if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
            sliderComponent.resetPages();
          }
        } else {
          activeMedia.scrollIntoView();
          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        }

        const deferredMedia = activeMedia.nodeName === 'DEFERRED-MEDIA' ? activeMedia : activeMedia.querySelector('deferred-media');
        if (
          deferredMedia &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
